// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"1516":"ProductPage","5072":"Cart","6459":"Member"}[chunkId] || chunkId) + ".6953.js";
};